__turbopack_context__.v({
  "logo": "SkillSelect-module__w3dysW__logo",
  "name": "SkillSelect-module__w3dysW__name",
  "option": "SkillSelect-module__w3dysW__option",
});
